module.exports = __webpack_public_path__ + "img/win_evening.13bfd690.png";